import { AllCalendarTypes, CalendarType } from './CalendarSnippet.types';

const isCalendarTypeSupported = (calendarType: CalendarType): boolean => AllCalendarTypes.includes(calendarType);

export { isCalendarTypeSupported };
